// extracted by mini-css-extract-plugin
export default {"chips":"CChhP","chips__icon":"a3P9a","chips__subTitle":"DALwH","chips__label":"WfcVx","chips_disabled":"kZHPk"};